var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"19.5","cy":"19.5","r":"19.5","fill":"#F9F9F9","key":0}),React.createElement("path",{"fill":"#FF4552","fillRule":"nonzero","d":"M18.924 23.799l6.9-6.9a.6.6 0 000-.849l-.848-.849a.6.6 0 00-.849 0L18.5 20.83 15.873 18.2a.6.6 0 00-.849 0l-.848.849a.6.6 0 000 .849l3.9 3.9a.6.6 0 00.848 0z","key":1})]));
}

Check.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39"};

module.exports = Check;

Check.default = Check;
